import { union } from '@wix/wix-data-client-common/dist/esm/infra/unionType'

export const BINDING_TYPES = {
  Field: 'Field',
  Action: 'Action',
  Behavior: 'Behavior',
  Filter: 'Filter',
  TotalCount: 'TotalCount',
  Expression: 'Expression',
}

export const Binding = union('Binding', {
  Field: ({
    prop,
    fieldPath,
    fieldType,
    format = null,
    linkTarget = null,
  }) => ({
    type: BINDING_TYPES.Field,
    prop,
    fieldPath,
    fieldType,
    format,
    linkTarget,
  }),
  Action: ({ event, action, postAction = null }) => ({
    type: BINDING_TYPES.Action,
    event,
    action,
    postAction,
  }),
  Behavior: ({ behavior }) => ({ type: BINDING_TYPES.Behavior, behavior }),
  Filter: ({ prop, fieldPath }) => ({
    type: BINDING_TYPES.Filter,
    prop,
    fieldPath,
  }),
  TotalCount: ({ prop }) => ({ type: BINDING_TYPES.TotalCount, prop }),
  Expression: ({ prop, expression }) => ({
    type: BINDING_TYPES.Expression,
    prop,
    expression,
  }),
})

Binding.chain = function (fn) {
  return fn(this)
}

export const updateExpression = (binding, expression) =>
  Binding.Expression({
    prop: binding.prop,
    expression,
  })

export const updateFormat = (binding, format) =>
  Binding.Field({
    prop: binding.prop,
    fieldPath: binding.fieldPath,
    format,
  })

export const updateTarget = (binding, linkTarget) =>
  Binding.Field({
    prop: binding.prop,
    fieldPath: binding.fieldPath,
    linkTarget,
  })

export const updatePostAction = (binding, postAction) =>
  Binding.Action({
    event: binding.event,
    action: binding.action,
    postAction,
  })

export const createBindingFromObject = bindingObject => {
  switch (bindingObject.type) {
    case BINDING_TYPES.Field:
      return Binding.Field(bindingObject)
    case BINDING_TYPES.Action:
      return Binding.Action(bindingObject)
    case BINDING_TYPES.Behavior:
      return Binding.Behavior(bindingObject)
    case BINDING_TYPES.Filter:
      return Binding.Filter(bindingObject)
    case BINDING_TYPES.TotalCount:
      return Binding.TotalCount(bindingObject)
    case BINDING_TYPES.Expression:
      return Binding.Expression(bindingObject)
  }
}
